import * as angular from 'angular';
import DeviceService from './device.service';

export default angular
  .module('device', [])
  .service('DeviceService', DeviceService)
  .name;



// WEBPACK FOOTER //
// ./src/app/core/device/device.module.js